class PairingUIController {
  constructor(options) {
    this.pairingKeyID = options.pairingKeyID;
    this.checkForNewPairing();
  }

  showSuccessMessage = (hardwareType) => {
    $('#hardware_type').html(hardwareType);
    $('.box').addClass('hidden');
    $('#success').removeClass('hidden');
  }

  checkForNewPairing = () => {
    $.ajax({
      type: 'GET',
      url: `/pairing_keys/${this.pairingKeyID}/recent_pair`,
      success: (data) => {

        if (data) {
          this.showSuccessMessage(data.hardware_type);
          return
        }

        // Check again in 2 seconds if not succesful
        window.setTimeout(this.checkForNewPairing, 2000);
      }
    });
  }
}

window.PairingUIController = PairingUIController;
